import React from 'react';
import { Form, Formik, Field } from 'formik';
import * as Yup from 'yup';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FormButtons, FormRow, FileUpload } from '../controls';

const SponsorSchema = Yup.object().shape({
  sponsorName: Yup.string().required('Sponsor name is required'),
});

export const SponsorForm = ({
  sponsor,
  onFileUpload,
  onFileDelete,
  handleSave,
  handleRemove,
  ...props
}) => {
  const defaultValues = {
    sponsorName: sponsor.sponsorName || '',
    sponsorDescription: sponsor.sponsorDescription || '',
    links: sponsor.links || {
      instagram: '',
      twitter: '',
      facebook: '',
      web: '',
    },
  };

  var fileList = [];

  if (sponsor.photoURL) {
    fileList.push({
      uid: '-1',
      name: sponsor.sponsorPhoto,
      url: sponsor.photoURL,
      status: 'done',
    });
  }

  return (
    <Formik
      enableReinitialize
      initialValues={defaultValues}
      onSubmit={handleSave}
      validationSchema={SponsorSchema}
    >
      {({ errors, touched }) => (
        <Form>
          <div className="flex">
            <div className="flex w-3/4 items-center p-4">
              <FormRow label="Sponsor Name" errorName="sponsorName">
                <Field type="text" name="sponsorName" placeholder="Name" />
              </FormRow>
            </div>
            <div className="w-1/4 p-4">
              <FormRow>
                <div className="w-full">
                  <FileUpload
                    fileList={fileList}
                    onFileUpload={onFileUpload}
                    onFileDelete={onFileDelete}
                  />
                </div>
              </FormRow>
            </div>
          </div>
          <FormRow label="Description">
            <Field
              component="textarea"
              name="sponsorDescription"
              placeholder="Sponsor Description..."
            />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fas', 'globe']} />}>
            <Field type="text" name="links.web" placeholder="Website" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'facebook']} />}>
            <Field type="text" name="links.facebook" placeholder="Facebook" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'twitter']} />}>
            <Field type="text" name="links.twitter" placeholder="Twitter" />
          </FormRow>
          <FormRow label={<FontAwesomeIcon icon={['fab', 'instagram']} />}>
            <Field type="text" name="links.instagram" placeholder="Instagram" />
          </FormRow>
          <FormButtons
            showDelete={sponsor.sponsorId}
            label="Sponsor"
            onDelete={handleRemove}
          />
        </Form>
      )}
    </Formik>
  );
};
